// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cec-titlebar-button > div {
  cursor: pointer;
}
.user-popover {
  min-width: fit-content;
}
.user-popover .user-popover-content-wrapper {
  gap: 8px;
  padding: 12px 0 0;
  text-align: center;
}
.user-popover .user-popover-content-wrapper .user-information {
  text-align: center;
}
.user-popover .user-popover-content-wrapper .user-information h4 {
  margin-block: 0;
}
.user-popover .user-popover-content-wrapper .user-information p {
  font-size: smaller;
  margin-block: 0;
}
.user-popover .user-popover-content-wrapper .account-buttons {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-block: 24px;
  padding-inline: 36px;
  width: 100%;
}
.user-popover .user-popover-content-wrapper .account-buttons .popover-button {
  width: 100%;
}
.user-popover .user-popover-content-wrapper > span {
  font-size: smaller;
  font-weight: bold;
  margin-block: 0;
}
.user-popover .user-popover-content-wrapper .divider {
  border-top: 1px solid #eaeaea;
  margin-block: 10px;
  width: 300px;
}
.user-popover .user-popover-content-wrapper .legal-pages {
  display: flex;
  gap: 12px;
  justify-content: center;
}
.user-popover .user-popover-content-wrapper .legal-pages div {
  color: #7e7e7e;
  cursor: pointer;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/Components/TitleBar/UserPopover/UserPopover.less"],"names":[],"mappings":"AAEA;EACC,eAAA;AADD;AAIA;EACC,sBAAA;AAFD;AACA;EAIE,QAAA;EACA,iBAAA;EACA,kBAAA;AAFF;AAJA;EASG,kBAAA;AAFH;AAPA;EAYI,eAAA;AAFJ;AAVA;EAgBI,kBAAA;EACA,eAAA;AAHJ;AAdA;EAsBG,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;AALH;AAvBA;EA+BI,WAAA;AALJ;AA1BA;EAoCG,kBAAA;EACA,iBAAA;EACA,eAAA;AAPH;AA/BA;EA0CG,6BAAA;EACA,kBAAA;EACA,YAAA;AARH;AApCA;EAgDG,aAAA;EACA,SAAA;EACA,uBAAA;AATH;AAzCA;EAqDI,cAAA;EACA,eAAA;EACA,qBAAA;AATJ","sourcesContent":["@import (reference) \"../../../Styles/colors\";\n\n.cec-titlebar-button > div {\n\tcursor: pointer;\n}\n\n.user-popover {\n\tmin-width: fit-content;\n\n\t.user-popover-content-wrapper {\n\t\tgap: 8px;\n\t\tpadding: 12px 0 0;\n\t\ttext-align: center;\n\n\t\t.user-information {\n\t\t\ttext-align: center;\n\n\t\t\th4 {\n\t\t\t\tmargin-block: 0;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tfont-size: smaller;\n\t\t\t\tmargin-block: 0;\n\t\t\t}\n\t\t}\n\n\t\t.account-buttons {\n\t\t\talign-items: center;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 8px;\n\t\t\tmargin-block: 24px;\n\t\t\tpadding-inline: 36px;\n\t\t\twidth: 100%;\n\n\t\t\t.popover-button {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\n\t\t> span {\n\t\t\tfont-size: smaller;\n\t\t\tfont-weight: bold;\n\t\t\tmargin-block: 0;\n\t\t}\n\n\t\t.divider {\n\t\t\tborder-top: 1px solid @light-gray-1;\n\t\t\tmargin-block: 10px;\n\t\t\twidth: 300px;\n\t\t}\n\n\t\t.legal-pages {\n\t\t\tdisplay: flex;\n\t\t\tgap: 12px;\n\t\t\tjustify-content: center;\n\n\t\t\tdiv {\n\t\t\t\tcolor: @light-gray-2;\n\t\t\t\tcursor: pointer;\n\t\t\t\ttext-decoration: none;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
